import { QuizUser } from '../../pages/quiz/types';
import { StandardResponse, post, put, ResponseWithData, get } from '.';

export async function registerQuizUser(
  payload: QuizUser
): Promise<StandardResponse<QuizUser>> {
  const responseWithData: Promise<
    ResponseWithData<StandardResponse<QuizUser>>
  > = post('/api/quiz-user/register', payload);

  return responseWithData.then(res => res.data);
}

export async function updateQuizUserResult({
  userId,
  result
}: {
  userId: string;
  result: number; // 1 or 2
}): Promise<StandardResponse<QuizUser>> {
  const responseWithData: Promise<
    ResponseWithData<StandardResponse<QuizUser>>
  > = put(`/api/quiz-user/update-result/${userId}`, { userResult: result });

  return responseWithData.then(res => res.data);
}

export async function toggleReceiveEmails({
  userId,
  receiveEmails
}: {
  userId: string;
  receiveEmails: boolean;
}): Promise<StandardResponse<QuizUser>> {
  const responseWithData: Promise<
    ResponseWithData<StandardResponse<QuizUser>>
  > = put(`/api/quiz-user/toggle-receive-emails/${userId}`, {
    receiveEmails
  });

  return responseWithData.then(res => res.data);
}

export async function createNewUserFromQuiz({
  userId,
  password,
  nationalUser,
  termsAccepted
}: {
  userId: string;
  password: string;
  nationalUser: NationalUser;
  termsAccepted: { type: string; text: string }[];
}): Promise<StandardResponse<QuizUser>> {
  const responseWithData: Promise<
    ResponseWithData<StandardResponse<QuizUser>>
  > = post(`/api/quiz-user/new-user/${userId}`, {
    password,
    nationalUser,
    termsAccepted
  });

  return responseWithData.then(res => res.data);
}

export async function findQuizUser({
  email,
  cpf
}: {
  email: string;
  cpf: string;
}): Promise<StandardResponse<QuizUser>> {
  const responseWithData: Promise<
    ResponseWithData<StandardResponse<QuizUser>>
  > = post('/api/quiz-user/find-quiz-user', {
    email,
    cpf
  });

  return responseWithData.then(res => res.data);
}

export interface NationalFormInput {
  name: string;
  cpf: string;
  birthDate: string;
  sex: string;
  race: string;
  cep: string;
  street: string;
  number: string;
  complement: string;
  neighborhood: string;
  country: string;
  state: string;
  city: string;
  phone: string;
  cel: string;
  homeCountry: string;
  homeState: string;
  homeCity: string;
  birthPlace: string;
  nationality: string;
  occupationalSituation: string;
  educationLevel: string;
  email: string;
  quizUserId?: string;
}
export interface NationalUser extends NationalFormInput {
  successFetchingUser: boolean;
}

export async function crateNewNationalUser(params: NationalFormInput) {
  const responseWithData: Promise<
    ResponseWithData<StandardResponse<NationalUser>>
  > = post('/api/quiz-user/new-national-user', params);

  return responseWithData.then(res => res.data);
}

export type CepResponse = {
  cep: number;
  tipoLogradouro: string;
  logradouro: string;
  bairro: string;
  cidade: string;
  estado: string;
  estadoSigla: string;
  pais: string;
  paisSigla: string;
};

export type CitiesResponse = {
  nome: string;
  ibge: string;
};

export async function getCep(cep: string) {
  const responseWithData: Promise<
    ResponseWithData<StandardResponse<CepResponse>>
  > = get(`/cep/${cep}`);

  return responseWithData.then(res => res.data);
}

export async function getCityByState(state: string) {
  const responseWithData: Promise<
    ResponseWithData<StandardResponse<CitiesResponse[]>>
  > = get(`/cep/city/${state}`);

  return responseWithData.then(res => res.data);
}

// Teste de nivelamento
export type PlacementTestQuestion = {
  difficulty: number;
  options: string[];
  question: string;
  id: string;
  code?: string;
  type: string;
  subType: string;
  questionId: number;
};

export async function getPlacementTestQuestions() {
  const responseWithData: Promise<
    ResponseWithData<StandardResponse<PlacementTestQuestion[]>>
  > = get('/placement-test/questions');
  return responseWithData.then(res => res.data);
}

export type PlacementTestCorrection = {
  [key: string]: string;
};

export async function postPlacementTestCorrection(params: {
  answers: PlacementTestCorrection;
}) {
  const responseWithData: Promise<
    ResponseWithData<StandardResponse<{ result: number }>>
  > = post('/placement-test/correction', params);

  return responseWithData.then(res => res.data);
}

export async function postSendWelcomeMundoTechEmail() {
  const responseWithData: Promise<
    ResponseWithData<StandardResponse<{ result: string }>>
  > = post('/placement-test/send-welcome-mundotech-email', {});
  return responseWithData.then(res => res.data);
}
